export const SETTING_LOADING_SHOW = 'SETTING_LOADING_SHOW';
export const SETTING_RESET = 'SETTING_RESET';
export const SETTING_SHOW = 'SETTING_SHOW';
